/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_HInputs */

const en_auth_error_h = /** @type {(inputs: Auth_Error_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't finish signing you in`)
};

const es_auth_error_h = /** @type {(inputs: Auth_Error_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos completar tu inicio de sesión`)
};

/**
* | output |
* | --- |
* | "We couldn't finish signing you in" |
*
* @param {Auth_Error_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_h = /** @type {((inputs?: Auth_Error_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_h(inputs)
	return en_auth_error_h(inputs)
});